<template>
   <div id="map">
       
   </div>
   
</template>
<script>
import ic_type_poi from '@/assets/image/ic_type_poi.png';
import { 
    computed,
} from 'vue'
import {     
    businessTimeAndPhonePic,
    locationPics,
    locationVideo, 
} from '../view_message_appear/config'
import {
    ref,
} from 'vue'
import { useStore } from 'vuex'
import {
  defineComponent,
//   onBeforeMount,
  reactive,
//   toRefs,
//   watch,
//   ref,
  // onMounted,
//   getCurrentInstance,
  onMounted,
//   onBeforeUpdate,
  // nextTick,
} from "vue";
// import utils from '../utils/utils'
// import { Toast } from '@nutui/nutui'
const listTypeMap = new Map([
    ['infoVideos', locationVideo],
    ['locationVideo', locationVideo],
    ['locationPics', locationPics],
    ['businessPhonePic', businessTimeAndPhonePic],
    ['businessTimePic', businessTimeAndPhonePic],
])
// import { Notify } from "@nutui/nutui";
// import request from "@/utils/request";

const TMap = window.TMap;
// 照片回调方法的数据格式
//     val url: String,  连接
//     val lat: Double, 坐标
//     val lng: Double, 坐标
//     val angle: Double,   角度
//     val time: Long 时间戳
export default defineComponent({
    name: 'maploca',
    props: {
        list: Array, 
        userCheckDetail: Boolean,
        title: String,
        type: String,
        number: [Number, String],
        listType: String,
        latlng: String,
        ide: {
            type: String,
            default: 'ik'
        },
        pageType: [String, Number],
        userLocation: {
            type: String,
            default: '39.984120,116.307484'
        },
        // 是否限制拍摄视频（内部员工）
        isSetLimit: {
            type: [Boolean, String],
            default: false
        }
    },
    setup(props, ctx) {
        const data = reactive({
            map: '',
        })
        const showVideoDOM = ref(false)
        const imgSrcShow = computed(() => {
            return listTypeMap.get(props.listType)
        })
        const store = useStore();
        console.log(store, 'ort { UseStore } from vuex');
        // 查看图片
        const previewImageHandel = (type, title, index) => {
            ctx.emit('previewImg', {type, title, current: index, url: listTypeMap.get(props.listType)})
        }
        onMounted(() => {
            initdata();
        });
        const initdata = () => {
            console.log(props.userLocation, 'message_appear_detail');
            data.map=new TMap.Map('map',{
            //    id:'map',
               center: new TMap.LatLng(props.userLocation.split(',')[0], props.userLocation.split(',')[1]),//设置地图中心点坐标
               zoom:17,   //设置地图缩放级别
            //    mapStyleId: 'style1' //个性化地图样式设置
            })
            data.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
            data.map.removeControl(TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
            const indoorManager = data.map.getIndoorManager();
            indoorManager.initialize().then(() => {
                indoorManager.setAutoActive(false);
                // indoorManager.setActiveIndoorBuilding(false);
                indoorManager.setVisible(false);
            });
            data.markerLayer = new TMap.MultiMarker({
                map: data.map,  //指定地图容器
                //样式定义
                styles: {
                    //创建一个styleId为"myStyle"的样式（styles的子属性名即为styleId）
                    "myStyle": new TMap.MarkerStyle({ 
                        "width": 25,  // 点标记样式宽度（像素）
                        "height": 35, // 点标记样式高度（像素）
                        "src": ic_type_poi,  //图片路径
                        //焦点在图片中的像素位置，一般大头针类似形式的图片以针尖位置做为焦点，圆形点以圆心位置为焦点
                        "anchor": { x: 16, y: 32 }  
                    }) 
                },
                //点标记数据数组
                geometries: [{
                    "id": "1",   //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
                    "styleId": 'myStyle',  //指定样式id
                    "position": new TMap.LatLng(39.954104, 116.357503),  //点标记坐标位置
                    "properties": {//自定义属性
                        "title": "marker1"
                    }
                }]
            })
      // this.map.setAutoActive(false);
      // this.map.setActiveIndoorBuilding(false);
        }
        // 选择到图片或视频
        const fileChange = (re) => {
            let a;
            if (props.ide != 'ik') {
                a = document.getElementById(props.ide);
            } else if(re == 'video') {
                a = document.getElementById('loadfile1');
            } else {
                a = document.getElementById('loadfile');
            }
            
            console.log(a);
            console.log(a[1]);
            console.log(re);
            console.log(a.files[0]);
            // CosPutObjectwx(a.files[0])
            // const datas = {
            //     Url: "mapugc-user-1251316161.cos.ap-beijing.myqcloud.com/easyearn/yinHeHuiTu/evaluating/oA9LiwOVHRl63Ax_H19o7jQ0O8Xo/1701684936501.json"
            // }
            // console.log(datas, '获取url失败：');
            //   ctx.emit('photoadd', [{
            //     url: datas.Url,
            //     lat: store.state.location.split(',')[0],
            //     lng: store.state.location.split(',')[1],
            //     angle: '',
            //     time: new Date().getTime(),
            // }])
            // console.log(store.state.location, 'lat: store.state.Location.split(',')[0]');
          
            
        };
        // 上传图片
        return {
            previewImageHandel,
            imgSrcShow,
            showVideoDOM,
            store,
            fileChange,
        }
    },
})
</script>
<style lang='scss' scoped>
.inyt {
    position: relative;
    left: 0;
    width: 100%;
    height: 100%;
    top: -80px;
    height: 100%;
    opacity: 0;
}
// #loadfile{
// }
// #loadfile1{
//     position: relative;
//     left: 0;
//     width: 100%;
//     height: 100%;
//     top: -80px;
//     height: 100%;
//     opacity: 0;
// }
.uploadEx {
    display: inline-block;
    width: 80Px;
    height: 80Px;
    vertical-align: top;
    margin-right: 10Px;
    img {
        width: 100%;
        height: 100%;
        display: block;
        border-radius: 4px;
    }
    span {
        opacity: 0.5;
        font-weight: 500;
        font-size: 12Px;
        text-align: center;
        display: block;
        color: #17181A;
        margin-top: 8Px;
    }
}
.upladItem {
    display: inline-block;
    width: 80Px;
    height: 106Px;
    vertical-align: top;
    margin-right: 10Px;
    & :deep(.nut-cell) {
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        border-radius: 4px;
        overflow: hidden;
        .iconDelete {
            width: 14px;
            height: 14px;
            background: rgba(0, 0, 0, 0.7);
            color: white;
            position: absolute;
            top: 4px;
            right: 4px;
            font-size: 6px;
            border-radius: 50%;
        }
    }
    .nut_icon_span_box{
        width: 80Px;
        height: 80Px;
        display: block;
        text-align: center;
        line-height: 80Px;
    }
    img, video {
        width: 80Px;
        height: 80Px;
        border-radius: 4px;
        display: block;
    }
    .span {
        opacity: 0.5;
        font-weight: 500;
        font-size: 12Px;
        text-align: center;
        display: block;
        margin-top: 8Px;
        color: #17181A;
    }
    .redStar::after{
        content: '*';
        color: red;
        opacity: 1;
    }
}
.nut-cell{
    display: block;
    color: #000;
    line-height: unset;
    box-shadow: none;
}
.uploadCss {
    width: 80Px;
    height: 80Px;
    display: inline-block;
    vertical-align: top;
    div {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        img {
            width: 100%;
            height: 100%;
            display: block;
            border-radius: 4px;
        }
    }
    span {
        opacity: 0.5;
        font-weight: 500;
        font-size: 12px;
        text-align: center;
        display: block;
        margin-top: 9px;
    }
}
.videoShow{
    visibility: visible;
    // position: relative;
}
.videoHidden{
    visibility: hidden;
    // position: absolute;
}
</style>